import { render, staticRenderFns } from "./VMedia.vue?vue&type=template&id=79cb6d68&scoped=true&"
import script from "./VMedia.vue?vue&type=script&lang=js&"
export * from "./VMedia.vue?vue&type=script&lang=js&"
import style0 from "./VMedia.vue?vue&type=style&index=0&id=79cb6d68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cb6d68",
  null
  
)

export default component.exports